(function () {
  document.documentElement.classList.add('ss-v170');
  function decoratePrivacyBanner() {
    var banner = document.querySelector('#shopify-pc__banner, shopify-privacy-banner, [data-shopify-cookie-banner]');
    if (banner) banner.classList.add('ss-cookie-polished');
  }
  decoratePrivacyBanner();
  var observer = new MutationObserver(decoratePrivacyBanner);
  observer.observe(document.documentElement, { childList: true, subtree: true });
  document.querySelectorAll('[data-mobile-menu] a').forEach(function (link) {
    link.addEventListener('click', function () {
      var menu = link.closest('[data-mobile-menu]');
      if (!menu) return;
      menu.classList.remove('is-open');
      menu.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    });
  });
})();